import React, { useState } from 'react';
import dayjs from 'dayjs';

import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';

import BlankCard from '~components/atoms/BlankCard';
import Image from '~components/atoms/Image';
import LabelledInput from '~components/atoms/LabelledInput';
import ActionButton from '~components/atoms/ActionButton';
import Text from '~components/atoms/Text';

import AffinFlowerLogo from '~assets/images/affin-flower-logo.webp';
import * as Styles from './_login.module.scss';

import PackageJson from '../../../package.json';

const Login = () => {
    const dispatch = useAppDispatch();

    const isLoading = useAppSelector(state => state.auth.loadings.login);
    const error = useAppSelector(state => state.auth.errors.login);
    const lastLoginTime = useAppSelector(state => state.auth.loginTime);
    const lastLogoutTime = useAppSelector(state => state.auth.logoutTime);

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const handleLoginClick = () => dispatch(combinedActions.authLoginAttempt({ username, password }));

    return (
        <div className={Styles.container}>
            <BlankCard containerStyle={Styles['blank-card']}>
                <>
                    <div className={Styles.background} />

                    <div className={Styles['content-container']}>
                        <div className={Styles['content-subcontainer']}>
                            <Image src={AffinFlowerLogo} width='auto' />

                            <Text
                                label='Welcome'
                                isBold
                            />

                            <LabelledInput
                                label='User ID'
                                className={Styles.input}
                                onChange={(e) => {
                                    if (error) dispatch(combinedActions.authResetLoginState());
                                    setUsername(e.target.value);
                                }}
                            />

                            <LabelledInput
                                label='Password'
                                isPassword
                                className={Styles.input}
                                onChange={(e) => {
                                    if (error) dispatch(combinedActions.authResetLoginState());
                                    setPassword(e.target.value);
                                }}
                            />
                        </div>

                        {lastLoginTime && lastLogoutTime
                            && (
                                <div className={Styles['user-activity-container']}>
                                    <Text label='Sign Out Successful' />

                                    <div className={Styles['user-activity-subcontainer']}>
                                        <div>
                                            <Text label='Last signed in:' />

                                            <Text label={dayjs(lastLoginTime).format('dddd, DD MMM YYYY HH:mm')} />
                                        </div>

                                        <div>
                                            <Text label='Last signed out:' />

                                            <Text label={dayjs(lastLogoutTime).format('dddd, DD MMM YYYY HH:mm')} />
                                        </div>
                                    </div>
                                </div>
                            )
                        }

                        <div className={Styles['button-container']}>
                            <ActionButton
                                label='Sign In'
                                className={Styles.button}
                                onClick={handleLoginClick}
                                isLoading={isLoading}
                            />

                            <Text
                                isError
                                label={error}
                            />
                        </div>
                    </div>

                    <div className={Styles['version']}>
                        <p>{PackageJson.version} ({process.env.REACT_APP_ENV})</p>
                    </div>
                </>
            </BlankCard>
        </div>
    );
};

export default Login;
